<template>
    <button
        class="w-full outline-none border-none whitespace-nowrap text-gray-700 font-normal text-left hover:font-medium hover:bg-indigo-100 hover:text-indigo-600 block px-4 py-2 text-sm transition duration-300"
        :class="[{'text-gray-600 hover:text-gray-600 hover:bg-white' : disable}, buttonClass]"
        @click="$emit('click', value)"
        :value="value"
        :title="title"
        :disabled="disable">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "SimpleDropdownOption",

    props: {
        disable: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            required: true,
            description: "Allows v-model to work",
        },
        buttonClass: {
            required: false,
            description: "Edit the styling of the button (usually if its the already selected option)",
            default: "",
        },
        title: {
            required: false,
            default: "",
        }
    },
};
</script>
